<template>


<form id="time_slice_form">
  <div class="row no-gutters align-items-center" style="font-size:0.65em;background-color:#fff;color:rgb(34, 34, 34);padding:0px 12px;border-bottom:1px solid #eee;color:#666;" v-if="layer.time=='monthly'">
      <div class="col-2">
        <i class="bi bi-calendar4-range"></i> Choose a time period:
      </div>
      <div class="col-10">
        <div class="row no-gutters">
            <div class="col text-right" v-for="(m, i) in months" v-bind:key="m">
              <input class="form-check-input" v-model="timeSlice" type="radio" name="time_slice_input" :id="'time_slice_'+(i+1)" :value="i" style="margin-left:-0.9rem;">
              <label class="form-check-label" :for="'time_slice_'+(i+1)">&nbsp;{{ m }}</label>
            </div>
        </div>
      </div>
      <!--
      <div class="col col-10 offset-2" style="position:relative;top:-206px;margin-bottom:-200px;height:200px;z-index:99999999999;border:0px solid red;font-size:0.9em;">
        <div style="position:absolute;bottom:0;right:6px;padding:0px;width:100%;text-align:left;background-color:rgba(250,250,250,0.9);padding:5px;border:1px solid #ccc;">  
      </div>
    </div>-->

    <hr />    
  </div>
</form>

</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import _ from 'lodash';

export default {
    name: 'RasterMapTimeSlice',
    components: { },
    props: ['layer', 'layerTimeSlice'],
    data() {
      return {
        months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        timeSlice: 1
      };
    },
    computed: {
    },
    watch: {
      timeSlice() {
        this.$emit('set-band', (this.timeSlice+1))
      }
    }
}
</script>

<style scoped>
form {
  padding:0px;
  margin:0px;
}
</style>